/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import 'firebase/auth';
import { urls } from '../../core/utils/constants';
import SignInForm from './SignInForm';

const SignIn = () => {
  const isAuthenticated = useSelector((state) => state.uid !== '' && state.uid !== undefined);

  if (isAuthenticated) {
    return <Redirect to={urls.root.path} />;
  }
  return <SignInForm />;
};

export default SignIn;
